var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map-view-containers",attrs:{"data-v-step":"1"}},[_c('SceneViewDropdown',{staticClass:"select",attrs:{"options":['Map View', '2D', '3D'],"dropdownTitle":"select map scene"},on:{"onInput":_vm.handleSelectedViews}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }